// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReasonReactRouter from "reason-react/src/ReasonReactRouter.js";

function Link(Props) {
  var route = Props.route;
  var children = Props.children;
  return React.createElement("a", {
              href: route,
              onClick: (function (e) {
                  e.preventDefault();
                  return ReasonReactRouter.push(route);
                })
            }, children);
}

var make = Link;

export {
  make ,
  
}
/* react Not a pure module */
